import { FormGroup, FormControl, Validators } from '@angular/forms';
import { GCValidators } from '../../shared/validators/gc-validator';
import { UserService } from '../../shared/services/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
var PasswordResetComponent = (function () {
    function PasswordResetComponent(userService, route, translate, router) {
        var _this = this;
        this.userService = userService;
        this.route = route;
        this.translate = translate;
        this.router = router;
        this.activateToken = '';
        this.error = '';
        this.resetForm = new FormGroup({
            password: new FormControl('', [Validators.required, GCValidators.validatePassword()]),
            confirmPassword: new FormControl('', [Validators.required, GCValidators.validatePasswordComparison()]),
        });
        this.ngUnsubscribe = new Subject();
        route.params.takeUntil(this.ngUnsubscribe).subscribe(function (values) {
            _this.activateRoute(values);
        });
    }
    PasswordResetComponent.prototype.activateRoute = function (params) {
        if (params.lang) {
            this.translate.setDefaultLang(params.lang);
        }
        this.activateToken = params.token;
    };
    PasswordResetComponent.prototype.reset = function (event) {
        var _this = this;
        event.preventDefault();
        if (this.resetForm.valid) {
            this.userService.redeemPasswordReset(this.resetForm.value.password, this.activateToken).then(function (result) {
                _this.router.navigate(['/login']);
            });
        }
    };
    /**
     * On destroy cancel active subscriptions
     */
    PasswordResetComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    return PasswordResetComponent;
}());
export { PasswordResetComponent };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/pages/password-reset/password-reset.component.ts.pre-build-optimizer.js